import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AccountService } from './account.service';
import { SCAMP_API, APP_SETTINGS } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { EquipamentoComboBoxViewModel, ParametersPesquisaEquipamento } from '../pages/domain/viewmodels.models';


@Injectable({providedIn: 'root'})
export class MaterialService {
    
    constructor(
        private http: HttpClient, 
        private account: AccountService) 
    { }

    getMateriaisDisponiveis(): Observable<any[]> {
        return this.http.get<any[]>(
            `${SCAMP_API.accountApiV1}/materiais-disponiveis`, 
            {headers : this.account.composeHeaders()}
        );
    }



}
